import { RentLicensesActions } from './actionNames'
import initialState from './initialState'

export default function(
  store: IRentLicensesStore = initialState,
  action: any,
): IRentLicensesStore {
  switch (action.type) {
    case RentLicensesActions.RentLicensesAccepted:
      return {
        ...store,
        licenses: action.payload,
      }
  }
  return store
}

export interface IRentLicense {
  license: string
  id: string
  rooms: string[]
  selection_type: string
}

export interface IRentLicensesStore {
  licenses: IRentLicense[]
}
